// https://v12.ngrx.io/guide/store-devtools/recipes/exclude
export const extModules = [];
